import { render, staticRenderFns } from "./labelsZhuanqu.vue?vue&type=template&id=63702846&"
import script from "./labelsZhuanqu.vue?vue&type=script&lang=js&"
export * from "./labelsZhuanqu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports